import React, { memo, useMemo } from 'react';
import { css, type SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import {
  sharedStyles,
  sharedBoxShadow,
  sharedFontStyle,
} from '../sharedStyles';

interface DivCssProps {
  sharedStyles: SerializedStyles;
  sharedBoxShadow: SerializedStyles;
  secondaryBtnBg: string;
}

interface SpanCssProps {
  sharedFontStyle: SerializedStyles;
  secondaryBtnTxt: string;
}

interface SolidSecondaryButtonProps {
  secondaryBtnBg: string;
  secondaryBtnTxt: string;
}

const Div = styled.div`
  ${({ sharedStyles, sharedBoxShadow, secondaryBtnBg }: DivCssProps) => css`
    ${sharedStyles};
    ${sharedBoxShadow};
    background-color: ${secondaryBtnBg};
    padding: 12px 16px;
  `}
`;
const Span = styled.span`
  ${({ sharedFontStyle, secondaryBtnTxt }: SpanCssProps) => css`
    ${sharedFontStyle};
    color: ${secondaryBtnTxt};
  `}
`;

const SolidSecondaryButton: React.FC<SolidSecondaryButtonProps> = ({
  secondaryBtnBg,
  secondaryBtnTxt,
}) => {
  const divCssProps = useMemo(
    () => ({
      sharedStyles,
      sharedBoxShadow,
      secondaryBtnBg,
    }),
    [secondaryBtnBg]
  );

  const spanCssProps = useMemo(
    () => ({
      sharedFontStyle,
      secondaryBtnTxt,
    }),
    [secondaryBtnTxt]
  );

  return (
    <Div {...divCssProps}>
      <Span {...spanCssProps}>取消訂單</Span>
    </Div>
  );
};

export default memo(SolidSecondaryButton);
